var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4531",
    "data-name": "Rectangle 4531",
    width: 9.993,
    height: 9.16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11157",
    "data-name": "Group 11157",
    transform: "translate(-308.243 -745.527)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(308.243 745.527)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11154",
    "data-name": "Group 11154",
    transform: "translate(313.704 751.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11152",
    "data-name": "Group 11152",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44609",
    "data-name": "Path 44609",
    d: "M4.994,171H1.325A1.252,1.252,0,0,1,0,169.684q0-.774,0-1.548a.421.421,0,0,1,.417-.464.423.423,0,0,1,.415.467c0,.52,0,1.041,0,1.561a.423.423,0,0,0,.464.47H8.7a.419.419,0,0,0,.459-.462c0-.538,0-1.076,0-1.613a.415.415,0,0,1,.817-.108.631.631,0,0,1,.014.154c0,.525,0,1.05,0,1.574A1.246,1.246,0,0,1,8.7,171q-1.854,0-3.708,0",
    transform: "translate(0 -161.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44610",
    "data-name": "Path 44610",
    d: "M74.7,6.207V6.025q0-2.764,0-5.528a.734.734,0,0,1,.022-.2A.408.408,0,0,1,75.166,0a.421.421,0,0,1,.367.38c0,.047,0,.1,0,.143q0,2.757,0,5.515V6.2c.046-.031.077-.05.106-.073l1.3-1.039a.416.416,0,1,1,.528.64q-1.029.827-2.061,1.649a.415.415,0,0,1-.579,0q-1.007-.8-2.011-1.608a.414.414,0,1,1,.52-.645c.415.328.827.659,1.241.988.033.026.067.051.124.095",
    transform: "translate(-70.123 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.f7fe681040dbdccbe2f065f495e73052.svg";
export { ForwardRef as ReactComponent };